import { jsx as _jsx } from "react/jsx-runtime";
import { createRoot } from 'react-dom/client';
import { Main } from '@components/main';
const initialise = () => {
    console.log('app is initialised...');
    const domNode = document.getElementById('application-entry');
    if (domNode) {
        const root = createRoot(domNode);
        root.render(_jsx(Main, {}));
        return;
    }
    console.error('application-entry not found');
};
initialise();
